import createReducer from "../../createReducer";
import { googleSheetsWorksheetsHandlers } from "../handlers";
import { IGoogleSheetsState } from "../types";

export const getGoogleSheetWorksheets: IGoogleSheetsState = {
    isLoading: false,
    error: null,
    worksheets: null,
};

export default createReducer(getGoogleSheetWorksheets, googleSheetsWorksheetsHandlers);
